
import { aboutHero, whyChoose, mission, lookingAhead, contact } from "../../assets/data/aboutData";
import AboutHero from "./components/about/AboutHero";
import AboutWhyChoose from "./components/about/AboutWhyChoose";
import AboutMission from "./components/about/AboutMission";
import AboutLookingAhead from "./components/about/AboutLookingAhead";
import AboutContact from "./components/about/AboutContact";
import NavBar from "../shared/components/Navbar";
import Footer from "../shared/components/Footer";


const AboutPage = () => (
  <>
    <NavBar/>
    <AboutHero data={aboutHero} />
    <AboutWhyChoose data={whyChoose} />
    <AboutMission data={mission} />
    <AboutLookingAhead data={lookingAhead} />
    <AboutContact data={contact} />
    <Footer/>
  </>
);

export default AboutPage;
